/**
 * Internal dependencies
 */
import ATTACHMENT_ACTION from '@naruto/bgdcms/src/reducers/cores/attachment/events';
import {
  SetAttachmentContentInitialAction,
  SetAttachmentListAction,
  SetAttachmentListClearAction,
  Attachments
} from './types';

/* Initial */
export const SET_ATTACHMENT_INITIALIZE = (): SetAttachmentContentInitialAction => ({
  type: ATTACHMENT_ACTION.SET_ATTACHMENT_INITIALIZE
});

/* Attachment Action */
export const SET_ATTACHMENT_LIST = ({ list }: { list: Attachments }): SetAttachmentListAction => ({
  type: ATTACHMENT_ACTION.SET_ATTACHMENT_LIST,
  list
});
export const CLEAR_ATTACHMENT_LIST = (): SetAttachmentListClearAction => ({
  type: ATTACHMENT_ACTION.CLEAR_ATTACHMENT_LIST
});
